export default __webpack_public_path__ + "static/media/lose@2x.4af22b3a.png";